import { useEffect, useState } from 'react';

/**
 * Returns a debounced copy of `value`.
 * Changes to `value` are reflected after `delay` ms without updates.
 */
export default function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
}